import { Page } from "@/models/page-models/Page";

export const StatementOfAccount: Page = {
  "path": "statement-of-account",
  "name": "Statement Of Account ",
  "props": {
    "data": {
      "title": "Statement Of Account ",
      "arabicTitle": "كشف الحساب",
      "printable": "TRUE",
      "hidePrintHeaders": "TRUE",
      "url": "statement-of-account",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})",
                  "printable": false
                },
                {
                  "type": "datepicker",
                  "variable": "formData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE",
                  "printable": false
                },
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE",
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Get Account Statement",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToStatement",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/statement-of-account",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{formData.customer}}\",\"startDate\":\"{{formData.startDate}}\",\"endDate\":\"{{formData.endDate}}\"}"
                      },
                      "name": "redirectToStatement"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                },
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.accountStatement}}",
                  "color": "secondary",
                  "buttonType": "print"
                },
                {
                  "type": "button",
                  "label": "Open Statement Of Balance",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToStatement",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/statement-of-balance",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{formData.customer}}\"}"
                      },
                      "name": "redirectToStatement"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.accountStatement}}",
                  "color": "green"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_CustomerStatementDetails",
                  "variable": "fetchedData.selectedCustomer",
                  "label": "Customer Statement Details",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.accountStatement}}",
                  "config": {
                    "type": "account",
                    "startDateVariable": "formData.startDate",
                    "endDateVariable": "formData.endDate"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Account Statement",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.accountStatement}}",
                  "items": "fetchedData.accountStatement.data.documents",
                  "headers": [
                    {
                      "value": "__item.createdAt",
                      "text": "Posting Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "type",
                      "text": "Type",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,{{{{__item.endBalance}} - {{__item.startBalance}}}},>,0),Invoice,Payment)"
                    },
                    {
                      "value": "__item._id",
                      "text": "Doc #",
                      "type": "url",
                      "formula": "fn(CONDITIONAL,{{'{{__item.type}}'=='Credit Note'}},{{__item.typeId}},fn(CONDITIONAL,fn(LOGICAL,{{'{{__item.type}}'=='invoice'}},||,{{'{{__item.type}}'=='misc'}}),{{__item._id}},{{__item.invoicePaymentReceipt}}))",
                      "url": "fn(CONDITIONAL,{{'{{__item.type}}'=='misc'}},/misc-invoice/{{__item._id}},fn(CONDITIONAL,{{'{{__item.type}}'=='invoice'}},/invoice/{{__item._id}},fn(CONDITIONAL,{{'{{__item.type}}'=='Credit Note'}},/credit-note/{{__item._id}},/invoice-payment-receipt/{{__item.invoicePaymentReceipt}})))"
                    },
                    {
                      "value": "__item.description",
                      "text": "Description",
                      "formula": "fn(HELPER_FN,statementDescription,{{__item}})"
                    },
                    {
                      "value": "__item.amount",
                      "text": "Amount",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{{{__item.endBalance}} - {{__item.startBalance}}}})"
                    },
                    {
                      "value": "__item.endBalance",
                      "text": "Balance",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.endBalance}})"
                    },
                    {
                      "value": "__item.dueDate",
                      "text": "Due Date",
                      "formula": "fn(CONDITIONAL,{{'{{__item.type}}'=='invoice'}},fn(CONDITIONAL,{{'{{__item.status}}'=='Settled'}},Settled,fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{__item.createdAt}},{{fetchedData.selectedCustomer.termsAndConditions.paymentTerms.daysAfterInvoice}}))),-)"
                    }
                  ],
                  "tableType": "static",
                  "belowHeader": {
                    "endBalance": "fn(HELPER_FN,numFormat,fn(SUM,{{fetchedData.accountStatement.data.startBalance}},{{fetchedData.accountStatement.data.documents.0.startBalance}}),0)",
                    "description": "Opening Balance"
                  },
                  "footer": {
                    "endBalance": "fn(HELPER_FN,numFormat,fn(SUM,{{fetchedData.accountStatement.data.startBalance}},fn(HELPER_FN,endBalance,{{fetchedData.accountStatement.data.documents}})))",
                    "description": "Closing Balance"
                  },
                  "fontSize": "0.75rem",
                  "enableGoogleSheetExport": true,
                  "googlSheetFileName": "SOA {{fetchedData.selectedCustomer.alias}}",
                  "height": "70vh"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,Customer Service | Manager))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showMisc=true&showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getAllCustomers",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),||,fn(MATCH_ROLE,General Manager))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyQueryParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getQueryParams",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyQueryParams"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getAccountStatement",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/report/account-statement/{{formData.customer}}?startDate={{formData.startDate}}&endDate={{formData.endDate}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.accountStatement"
        },
        "name": "getAccountStatement",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,{{formData.customer}},>,0),&&,fn(NOT,fn(MATCH_ROLE,Sales | Account Executive)))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMyAccountStatement",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/report/my-customer-account-statement/{{formData.customer}}?startDate={{formData.startDate}}&endDate={{formData.endDate}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.accountStatement"
        },
        "name": "getMyAccountStatement",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,{{formData.customer}},>,0),&&,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copySelectedCustomer",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "findSelectedCustomer",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.selectedCustomer"
        },
        "name": "copySelectedCustomer"
      }
    ],
    "functions": [
      {
        "name": "getQueryParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "fn(NUMBER,{{__query.customer}})",
          "startDate": "fn(CONDITIONAL,{{__query.startDate}},{{__query.startDate}},fn(HELPER_FN,dateFormat,{{YEAR_START}},date-picker))",
          "endDate": "fn(CONDITIONAL,{{__query.endDate}},{{__query.endDate}},fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker))"
        },
        "useFormula": true
      },
      {
        "name": "findSelectedCustomer",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.customers.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "formData.customer"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,CUSTOMER_SERVICE_MANAGER,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 60,
  "menuGroup": "Reports"
}